export function hasHeader(soughtHeader, headers) {
    soughtHeader = soughtHeader.toLowerCase();
    for (var _i = 0, _a = Object.keys(headers); _i < _a.length; _i++) {
        var headerName = _a[_i];
        if (soughtHeader === headerName.toLowerCase()) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=hasHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/signature-v4/dist/es/hasHeader.js
// module id = null
// module chunks = 